import { serializeConstant } from "./constant";
export var RegisterId;
(function (RegisterId) {
    RegisterId["R4"] = "R4";
    RegisterId["R5"] = "R5";
    RegisterId["R6"] = "R6";
    RegisterId["R7"] = "R7";
    RegisterId["R8"] = "R8";
    RegisterId["R9"] = "R9";
})(RegisterId || (RegisterId = {}));
export function parseRegisterId(s) {
    switch (s) {
        case "R4":
            return RegisterId.R4;
        case "R5":
            return RegisterId.R5;
        case "R6":
            return RegisterId.R6;
        case "R7":
            return RegisterId.R7;
        case "R8":
            return RegisterId.R8;
        case "R9":
            return RegisterId.R9;
    }
    return undefined;
}
export const EmptyRegisters = {};
export const AdditionalRegisters = [4, 5, 6, 7, 8, 9];
export function registers(regs) {
    const acc = {};
    for (const [id, value] of regs)
        acc[id] = serializeConstant(value);
    return acc;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVnaXN0ZXJzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2VudGl0aWVzL3JlZ2lzdGVycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxPQUFPLEVBQVcsaUJBQWlCLEVBQUMsTUFBTSxZQUFZLENBQUE7QUFFdEQsTUFBTSxDQUFOLElBQVksVUFPWDtBQVBELFdBQVksVUFBVTtJQUNwQix1QkFBUyxDQUFBO0lBQ1QsdUJBQVMsQ0FBQTtJQUNULHVCQUFTLENBQUE7SUFDVCx1QkFBUyxDQUFBO0lBQ1QsdUJBQVMsQ0FBQTtJQUNULHVCQUFTLENBQUE7QUFDWCxDQUFDLEVBUFcsVUFBVSxLQUFWLFVBQVUsUUFPckI7QUFFRCxNQUFNLFVBQVUsZUFBZSxDQUFDLENBQVM7SUFDdkMsUUFBUSxDQUFDLEVBQUU7UUFDVCxLQUFLLElBQUk7WUFDUCxPQUFPLFVBQVUsQ0FBQyxFQUFFLENBQUE7UUFDdEIsS0FBSyxJQUFJO1lBQ1AsT0FBTyxVQUFVLENBQUMsRUFBRSxDQUFBO1FBQ3RCLEtBQUssSUFBSTtZQUNQLE9BQU8sVUFBVSxDQUFDLEVBQUUsQ0FBQTtRQUN0QixLQUFLLElBQUk7WUFDUCxPQUFPLFVBQVUsQ0FBQyxFQUFFLENBQUE7UUFDdEIsS0FBSyxJQUFJO1lBQ1AsT0FBTyxVQUFVLENBQUMsRUFBRSxDQUFBO1FBQ3RCLEtBQUssSUFBSTtZQUNQLE9BQU8sVUFBVSxDQUFDLEVBQUUsQ0FBQTtLQUN2QjtJQUNELE9BQU8sU0FBUyxDQUFBO0FBQ2xCLENBQUM7QUFJRCxNQUFNLENBQUMsTUFBTSxjQUFjLEdBQXdCLEVBQUUsQ0FBQTtBQUVyRCxNQUFNLENBQUMsTUFBTSxtQkFBbUIsR0FBRyxDQUFDLENBQUMsRUFBRSxDQUFDLEVBQUUsQ0FBQyxFQUFFLENBQUMsRUFBRSxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUE7QUFFckQsTUFBTSxVQUFVLFNBQVMsQ0FBQyxJQUE4QjtJQUN0RCxNQUFNLEdBQUcsR0FBYyxFQUFFLENBQUE7SUFDekIsS0FBSyxNQUFNLENBQUMsRUFBRSxFQUFFLEtBQUssQ0FBQyxJQUFJLElBQUk7UUFBRSxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsaUJBQWlCLENBQUMsS0FBSyxDQUFDLENBQUE7SUFDbEUsT0FBTyxHQUFHLENBQUE7QUFDWixDQUFDIn0=